import { Injectable } from '@angular/core';
import { Controparte } from './controparte';
import { DatiReato } from "./dati-reato";

@Injectable()
export class Reato {
  id: string;
  controparte: Controparte;
  datiReato: DatiReato[];
}
